import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import axios from 'axios'
import './assets/iconfont/iconfont.css'
import './assets/font/iconfont.css'
import qs from 'qs'

import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/index.scss'
import router from './router'
import store from './store'

import BaiduMap from 'vue-baidu-map'
import project from './plugins/project'

Vue.use(project)
Vue.use(ElementUI)

Vue.use(BaiduMap, {
  ak: '7QFcH7CSL8vsj2XENuzH6UC1SPd4rjDn'
})

Vue.prototype.$message = function (options) {
  ElementUI.Message(Object.assign({}, options, { duration: '2000' }))
}

Vue.prototype.$message.success = function (msg) {
  ElementUI.Message.success({
    message: msg,
    duration: 2000
  })
}

Vue.prototype.$message.error = function (msg) {
  ElementUI.Message.error({
    message: msg,
    duration: 2000
  })
}

Vue.prototype.$message.warning = function (msg) {
  ElementUI.Message.warning({
    message: msg,
    duration: 2000
  })
}

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

axios.interceptors.request.use(function (config) {
  if (sessionStorage.token) {
    config.headers.userToken = sessionStorage.token
  }
  // 在发送请求之前做些什么
  // config.url = '/api' + config.url
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
var iTime
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  let code = response.data.code
  let success = response.data.success
  if (!success) {
    if (code == 'B003') { // 未登录
      if (response.data.message) {
        ElementUI.Message.error({
          message: response.data.message,
          duration: 1000
        })
      }
      window.open('/login', '_self')
      sessionStorage.clear()
    } else {
      if (response.data.message) {
        clearTimeout(iTime)
        iTime = setTimeout(() => {
          ElementUI.Message.error({
            message: response.data.message,
            duration: 2000
          })
        }, 200)
      }
    }
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  console.log(error.response.status, 'response error')
  if (error.response.status && error.response.status != 200) {
    clearTimeout(iTime)
    iTime = setTimeout(() => {
      ElementUI.Message.error({
        message: '服务器繁忙，请稍后再试',
        duration: 2000
      })
    }, 200)
  }
  return Promise.reject(error)
})

Vue.prototype.$dateFormat = function (date, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (!date) {
    return ''
  }
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'))
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  var o = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  var week = {
    '0': '\u65e5',
    '1': '\u4e00',
    '2': '\u4e8c',
    '3': '\u4e09',
    '4': '\u56db',
    '5': '\u4e94',
    '6': '\u516d'
  }
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
